import { render, staticRenderFns } from "./CompanionEditorView.vue?vue&type=template&id=48aab4b4&scoped=true"
import script from "./CompanionEditorView.vue?vue&type=script&lang=js"
export * from "./CompanionEditorView.vue?vue&type=script&lang=js"
import style0 from "./CompanionEditorView.vue?vue&type=style&index=0&id=48aab4b4&prod&scoped=true&lang=scss"
import style1 from "./CompanionEditorView.vue?vue&type=style&index=1&id=48aab4b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aab4b4",
  null
  
)

export default component.exports